import { forwardRef } from "react";
import TextField from "@material-ui/core/TextField";
import React from "react";

const phoneInput = (props: any, ref: any): JSX.Element => {
	return <TextField {...props} inputRef={ref} fullWidth variant="outlined" />;
};

export default forwardRef(phoneInput);
